(function () {

var path = window.location.pathname.toLowerCase();
  
  var WANT = ['price', 'material', 'color', 'size', 'lace'];

  if (path.indexOf('/collections/best-sellers') !== -1) {
  WANT.push('product group');
}

  function norm(t){
    return String(t||'').toLowerCase().replace(/\s+/g,' ').trim();
  }

  function isPC(){
    return window.matchMedia('(min-width: 1025px)').matches;
  }

  function ensureOverlay(){
    var ov = document.querySelector('.scx-filters-overlay');
    if (!ov){
      ov = document.createElement('div');
      ov.className = 'scx-filters-overlay';
      document.body.appendChild(ov);
    }
    return ov;
  }

  function getSidebar(){
    var el = document.querySelector('#halo-sidebar');
    if (!el) return null;
    // 标记一下：只用于 PC 抽屉
    el.setAttribute('data-scx-drawer','filters');
    return el;
  }

  function closeDrawer(){
    document.body.classList.remove('scx-filters-open');
  }
  function openDrawer(){
    document.body.classList.add('scx-filters-open');
  }

  // 找到 sidebar 里的区块标题（Price/Material/Color/Size/Lace）
  function findBlocks(sidebar){
    var heads = sidebar.querySelectorAll('.sidebarBlock-heading, .sidebarBlock-headingWrapper .sidebarBlock-heading');
    var map = {}; // key -> headingEl
    heads.forEach(function(h){
      var key = norm(h.textContent);
      // 有些主题可能是 "Price" / "PRICE" / "Price Range" 之类，这里做包含匹配
      WANT.forEach(function(w){
        if (!map[w] && key.indexOf(w) !== -1) map[w] = h;
      });
    });
    return map;
  }

  function collapseAll(sidebar){
    // 用主题已有的 is-clicked 逻辑收起
    var clicked = sidebar.querySelectorAll('.sidebarBlock-heading.is-clicked');
    clicked.forEach(function(h){ h.classList.remove('is-clicked'); });
  }

  function expandBlock(headingEl){
    if (!headingEl) return;
    // 触发主题原 click（最稳），不行再强行加 class
    try { headingEl.click(); } catch(e){}
    headingEl.classList.add('is-clicked');
    // 滚到可视区域
    setTimeout(function(){
      try { headingEl.scrollIntoView({block:'start', behavior:'smooth'}); } catch(e){}
    }, 50);
  }

  function mountChips(){
    if (!isPC()) return;

    var sidebar = getSidebar();
    if (!sidebar) return;

    document.body.classList.add('scx-filters-enabled'); // 只让 PC CSS 生效
    closeDrawer();                                     // 刷新默认关闭

    var ov = ensureOverlay();
    ov.addEventListener('click', closeDrawer);

    // 右上角 X（主题自带）
    var closeBtn = sidebar.querySelector('.halo-sidebar-close,[data-close-sidebar]');
    if (closeBtn){
      closeBtn.addEventListener('click', function(e){
        e.preventDefault();
        closeDrawer();
      });
    }

    // ESC 关闭
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeDrawer();
    });

    // chips 插到 toolbar 里（你截图里的那条工具栏）
    var toolbar = document.querySelector('.toolbar-wrapper') || document.querySelector('.toolbar') || document.querySelector('#CollectionProductGrid');
    if (!toolbar) return;

    // 防重复
    if (document.querySelector('.scx-filter-chips')) return;

    var chips = document.createElement('div');
    chips.className = 'scx-filter-chips';

    var blockMap = findBlocks(sidebar);

    WANT.forEach(function(k){
      if (!blockMap[k]) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'scx-filter-chip';
      btn.textContent = blockMap[k].textContent.trim();

      btn.addEventListener('click', function(){
        openDrawer();
        collapseAll(sidebar);
        expandBlock(blockMap[k]);
      });

      chips.appendChild(btn);
    });

    // 你希望像参考图那样在 “Filter By:” 后面一排按钮
    var wrap = document.createElement('div');
    wrap.style.display = 'flex';
    wrap.style.alignItems = 'center';
    wrap.style.gap = '12px';

    var label = document.createElement('div');
    label.textContent = 'Filter By:';
    label.style.whiteSpace = 'nowrap';

    wrap.appendChild(label);
    wrap.appendChild(chips);

    // 插入到 toolbar 最前面
    toolbar.insertBefore(wrap, toolbar.firstChild);
  }

  // 只在 PC 装载 chips；移动端完全不动主题（避免被影响）
  function init(){
    // 任何情况下先确保不会“刷新就开”
    document.body.classList.remove('scx-filters-open');

    // 关键：不要动 open-mobile-sidebar（那是移动端原生弹层开关）
    // PC 才加 enabled
    if (isPC()) mountChips();
    else document.body.classList.remove('scx-filters-enabled');
  }

  window.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', function(){
    // 宽度跨 1025 需要重新初始化一次
    init();
  });
})();
